module.exports = __webpack_public_path__ + "img/imagen4.49df90d9.png";